
export default {
  placesCarousel: {
    layer: 'Layer',
    lat: 'Lat.',
    lon: 'Lon.',
    notAvailable: 'Not available',
    placeDetails: 'Place details',
    next: 'Next block',
    prev: 'Previous block',
    directionsTo: 'Directions to',
    distance: 'Distance',
    distanceFromLocationMarkedOnTheMap: 'Approximate distance from location marked on the map',
    selectPlace: 'Select'
  }
}
